// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Sd from "common/src/tft-static/Sd.bs.js";
import * as Dict from "common/src/util/Dict.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Data12 from "common/src/data/Data12.bs.js";
import * as Data13 from "common/src/data/Data13.bs.js";
import * as Data14 from "common/src/data/Data14.bs.js";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as CdnAtom from "common/src/atoms/CdnAtom.bs.js";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as ItemImage from "common/src/tft-static/ItemImage.bs.js";
import * as UnitImage from "common/src/tft-static/UnitImage.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as SupSection from "./SupSection.bs.js";
import * as ItemTooltip from "common/src/tft-static/ItemTooltip.bs.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as TraitInfoCard from "../info/TraitInfoCard.bs.js";
import * as ContentSection from "common/src/ContentSection.bs.js";
import * as RitoDescription2 from "common/src/components/RitoDescription2.bs.js";

function SupTraits$JunkerKingCard(Props) {
  TftSet.use(undefined);
  var match = React.useState(function () {
        return 0;
      });
  var setModIdx = match[1];
  var modIdx = match[0];
  var itemsT = Translation.useT(/* Items */3);
  var traitsT = Translation.useT(/* Traits */2);
  var tattoos = React.useMemo((function () {
          return Belt_Array.keep(Js_dict.entries(Data13.items), (function (param) {
                        var itemId = param[0];
                        if (itemId.includes("JunkerKing") && !itemId.includes("Pass")) {
                          return !itemId.includes("Emblem");
                        } else {
                          return false;
                        }
                      }));
        }), []);
  var match$1 = Belt_Array.getExn(tattoos, modIdx);
  var modId = match$1[0];
  return React.createElement(ContentSection.make, {
              children: null
            }, React.createElement("h3", {
                  className: "inline-block text-xl font-montserrat font-medium pb-1"
                }, traitsT("TFT13_JunkerKing") + "Upgrades"), React.createElement("div", {
                  className: "flex mb-5 mt-2 gap-2"
                }, Belt_Array.mapWithIndex(tattoos, (function (idx, param) {
                        var id = param[0];
                        return React.createElement("div", {
                                    key: id,
                                    className: "cursor-pointer",
                                    onClick: (function (param) {
                                        return Curry._1(setModIdx, (function (param) {
                                                      return idx;
                                                    }));
                                      })
                                  }, React.createElement(ItemImage.make, {
                                        itemId: id,
                                        size: 26,
                                        className: idx === modIdx ? "" : "opacity-50",
                                        rounded: "rounded"
                                      }));
                      }))), React.createElement("div", {
                  className: "flex items-center gap-2 pb-2"
                }, React.createElement(ItemImage.make, {
                      itemId: modId,
                      size: 36,
                      rounded: "rounded"
                    }), React.createElement("div", undefined, React.createElement("div", {
                          className: "pb-1"
                        }, itemsT(modId)))), React.createElement(ItemTooltip.BaseStats.make, {
                  item: match$1[1]
                }), React.createElement(RitoDescription2.make, {
                  desc: itemsT(modId + "_desc"),
                  className: "text-sm leading-tight"
                }));
}

var JunkerKingCard = {
  make: SupTraits$JunkerKingCard
};

function SupTraits$ExotechCard(Props) {
  TftSet.use(undefined);
  var match = React.useState(function () {
        return 0;
      });
  var setModIdx = match[1];
  var modIdx = match[0];
  var itemsT = Translation.useT(/* Items */3);
  var traitsT = Translation.useT(/* Traits */2);
  var tattoos = React.useMemo((function () {
          return Belt_Array.keep(Js_dict.entries(Data14.items), (function (param) {
                        return param[0].includes("CyberneticItem");
                      }));
        }), []);
  var match$1 = Belt_Array.getExn(tattoos, modIdx);
  var modId = match$1[0];
  return React.createElement(ContentSection.make, {
              children: null
            }, React.createElement("h3", {
                  className: "inline-block text-xl font-montserrat font-medium pb-1"
                }, traitsT("TFT14_EdgeRunner") + " Items"), React.createElement("div", {
                  className: "flex mb-5 mt-2 gap-2"
                }, Belt_Array.mapWithIndex(tattoos, (function (idx, param) {
                        var id = param[0];
                        return React.createElement("div", {
                                    key: id,
                                    className: "cursor-pointer",
                                    onClick: (function (param) {
                                        return Curry._1(setModIdx, (function (param) {
                                                      return idx;
                                                    }));
                                      })
                                  }, React.createElement(ItemImage.make, {
                                        itemId: id,
                                        size: 26,
                                        className: idx === modIdx ? "" : "opacity-50",
                                        rounded: "rounded"
                                      }));
                      }))), React.createElement("div", {
                  className: "flex items-center gap-2 pb-2"
                }, React.createElement(ItemImage.make, {
                      itemId: modId,
                      size: 36,
                      rounded: "rounded"
                    }), React.createElement("div", undefined, React.createElement("div", {
                          className: "pb-1"
                        }, itemsT(modId)))), React.createElement(ItemTooltip.BaseStats.make, {
                  item: match$1[1]
                }), React.createElement(RitoDescription2.make, {
                  desc: itemsT(modId + "_desc"),
                  className: "text-sm leading-tight"
                }));
}

var ExotechCard = {
  make: SupTraits$ExotechCard
};

function SupTraits$FaerieCard(Props) {
  TftSet.use(undefined);
  var match = React.useState(function () {
        return 0;
      });
  var setModIdx = match[1];
  var modIdx = match[0];
  var itemsT = Translation.useT(/* Items */3);
  var tattoos = React.useMemo((function () {
          return Belt_Array.keep(Js_dict.entries(Data12.items), (function (param) {
                        var itemId = param[0];
                        if (itemId.includes("Faerie")) {
                          return !itemId.includes("Emblem");
                        } else {
                          return false;
                        }
                      }));
        }), []);
  var match$1 = Belt_Array.getExn(tattoos, modIdx);
  var modId = match$1[0];
  return React.createElement(ContentSection.make, {
              children: null
            }, React.createElement("h3", {
                  className: "inline-block text-xl font-montserrat font-medium pb-1"
                }, "Faerie Items"), React.createElement("div", {
                  className: "flex mb-5 mt-2 gap-2"
                }, Belt_Array.mapWithIndex(tattoos, (function (idx, param) {
                        var id = param[0];
                        return React.createElement("div", {
                                    key: id,
                                    className: "cursor-pointer",
                                    onClick: (function (param) {
                                        return Curry._1(setModIdx, (function (param) {
                                                      return idx;
                                                    }));
                                      })
                                  }, React.createElement(ItemImage.make, {
                                        itemId: id,
                                        size: 26,
                                        className: idx === modIdx ? "" : "opacity-50",
                                        rounded: "rounded"
                                      }));
                      }))), React.createElement("div", {
                  className: "flex items-center gap-2 pb-2"
                }, React.createElement(ItemImage.make, {
                      itemId: modId,
                      size: 36,
                      rounded: "rounded"
                    }), React.createElement("div", undefined, React.createElement("div", {
                          className: "pb-1"
                        }, itemsT(modId)))), React.createElement(ItemTooltip.BaseStats.make, {
                  item: match$1[1]
                }), React.createElement(RitoDescription2.make, {
                  desc: itemsT(modId + "_desc"),
                  className: "text-sm leading-tight"
                }));
}

var FaerieCard = {
  make: SupTraits$FaerieCard
};

function SupTraits$ArcanaCard(Props) {
  var units = [
    "Ahri",
    "Hecarim",
    "TahmKench",
    "Xerath",
    "Emblem"
  ];
  var match = React.useState(function () {
        return 0;
      });
  var setModIdx = match[1];
  var modIdx = match[0];
  var traitsT = Translation.useT(/* Traits */2);
  return React.createElement(ContentSection.make, {
              children: null
            }, React.createElement("h3", {
                  className: "inline-block text-xl font-montserrat font-medium pb-1"
                }, "Arcana Variants"), React.createElement("div", {
                  className: "flex mb-4 mt-2 gap-3"
                }, Belt_Array.mapWithIndex(units, (function (idx, id) {
                        return React.createElement("div", {
                                    key: id,
                                    className: "cursor-pointer",
                                    onClick: (function (param) {
                                        return Curry._1(setModIdx, (function (param) {
                                                      return idx;
                                                    }));
                                      })
                                  }, id === "Emblem" ? React.createElement(ItemImage.make, {
                                          itemId: "12ArcanaEmblemItem",
                                          size: 40,
                                          className: idx === modIdx ? "" : "opacity-50"
                                        }) : React.createElement(UnitImage.make, {
                                          unitId: "TFT12_" + id,
                                          size: 40,
                                          className: idx === modIdx ? "" : "opacity-50"
                                        }));
                      }))), React.createElement(RitoDescription2.make, {
                  desc: traitsT("TFT12_Arcana_" + Belt_Array.getExn(units, modIdx) + "_desc"),
                  className: "text-sm leading-tight"
                }));
}

var ArcanaCard = {
  make: SupTraits$ArcanaCard
};

function SupTraits$EldritchCard(Props) {
  var units = [
    "TFT12_EldritchDaisy",
    "TFT12_EldritchMalphite",
    "TFT12_EldritchVolibear",
    "TFT12_EldritchBigVolibear"
  ];
  var match = React.useState(function () {
        return 0;
      });
  var setModIdx = match[1];
  var modIdx = match[0];
  var unitsT = Translation.useT(/* Units */1);
  var unitId = Belt_Array.getExn(units, modIdx);
  var basePath3 = CdnAtom.usePath4(undefined);
  var info = Dict.getExn(Data12.units, unitId);
  return React.createElement(ContentSection.make, {
              children: null
            }, React.createElement("h3", {
                  className: "inline-block text-xl font-montserrat font-medium pb-1"
                }, "Eldritch Summons"), React.createElement("div", {
                  className: "flex mb-4 mt-2 gap-3"
                }, Belt_Array.mapWithIndex(units, (function (idx, id) {
                        return React.createElement("div", {
                                    key: id,
                                    className: "cursor-pointer",
                                    onClick: (function (param) {
                                        return Curry._1(setModIdx, (function (param) {
                                                      return idx;
                                                    }));
                                      })
                                  }, React.createElement(UnitImage.make, {
                                        unitId: id,
                                        size: 40,
                                        className: idx === modIdx ? "" : "opacity-50"
                                      }));
                      }))), React.createElement("div", {
                  className: "text-lg pb-1 font-montserrat font-medium"
                }, unitsT(unitId)), React.createElement("div", {
                  className: "flex items-center mt-1 mb-2"
                }, React.createElement("img", {
                      className: "rounded flex-shrink-0 w-[22px] h-[22px]",
                      height: "22",
                      src: basePath3 + "/s12up/ability/" + unitId + ".jpg?w=22",
                      width: "22"
                    }), React.createElement("div", {
                      className: "flex items-center pl-2 leading-none"
                    }, React.createElement("div", {
                          className: "font-medium text-sm"
                        }, unitsT(unitId + "_ability")), info.stats.mana > 0 ? React.createElement("div", {
                            className: "flex items-center pt-[2px] h-[18px] text-sm pl-2"
                          }, React.createElement("div", {
                                className: "mt-[-1px] mr-[2px] w-[14px] h-[14px]"
                              }, React.createElement("img", {
                                    alt: "Mana",
                                    height: "14",
                                    src: basePath3 + "/general/mana.png",
                                    width: "14"
                                  })), React.createElement("div", {
                                className: "pt-[1px]"
                              }, String(info.stats.initialMana) + "/" + String(info.stats.mana))) : null)), React.createElement(RitoDescription2.make, {
                  desc: unitsT(unitId + "_desc"),
                  className: "text-sm leading-tight"
                }));
}

var EldritchCard = {
  make: SupTraits$EldritchCard
};

function SupTraits(Props) {
  var set = TftSet.use(undefined);
  var origins = Sd.allOrigins(set);
  var classes = Sd.allClasses(set);
  var t = Translation.useT(/* Common */0);
  return React.createElement(SupSection.make, {
              children: null,
              id: "set-update-traits",
              title: t("Traits")
            }, React.createElement("div", {
                  className: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8"
                }, Belt_Array.map(origins, (function (traitId) {
                        if (traitId === "TFT17_Stargazer") {
                          return React.createElement(React.Fragment, {
                                      children: null,
                                      key: traitId
                                    }, React.createElement(TraitInfoCard.make, {
                                          traitId: traitId
                                        }), React.createElement(TraitInfoCard.make, {
                                          traitId: traitId,
                                          suffix: "_Huntress",
                                          key: traitId
                                        }), React.createElement(TraitInfoCard.make, {
                                          traitId: traitId,
                                          suffix: "_Fountain",
                                          key: traitId
                                        }), React.createElement(TraitInfoCard.make, {
                                          traitId: traitId,
                                          suffix: "_Medallion",
                                          key: traitId
                                        }), React.createElement(TraitInfoCard.make, {
                                          traitId: traitId,
                                          suffix: "_Mountain",
                                          key: traitId
                                        }), React.createElement(TraitInfoCard.make, {
                                          traitId: traitId,
                                          suffix: "_Serpent",
                                          key: traitId
                                        }), React.createElement(TraitInfoCard.make, {
                                          traitId: traitId,
                                          suffix: "_Shield",
                                          key: traitId
                                        }), React.createElement(TraitInfoCard.make, {
                                          traitId: traitId,
                                          suffix: "_Wolf",
                                          key: traitId
                                        }));
                        } else {
                          return React.createElement(TraitInfoCard.make, {
                                      traitId: traitId,
                                      key: traitId
                                    });
                        }
                      }))), React.createElement("div", {
                  className: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 pt-16"
                }, Belt_Array.map(classes, (function (traitId) {
                        return React.createElement(TraitInfoCard.make, {
                                    traitId: traitId,
                                    key: traitId
                                  });
                      }))));
}

var make = SupTraits;

export {
  JunkerKingCard ,
  ExotechCard ,
  FaerieCard ,
  ArcanaCard ,
  EldritchCard ,
  make ,
  
}
/* Sd Not a pure module */
